<template>
  <div>
    <fieldset>
      <legend class="h4">{{ $t('selectDay') }}</legend>
      <WCSelectBoxGroup class="position-relative">
        <button
          class="align-self-center text-primary wc-chevron-left unstyled-btn p-0 m-0"
          v-if="options.length > 6 && daysSet !== 1"
          @click="daysSet -= 1"
          :aria-label="$t('viewPrevDateSet')"
        >
          <font-awesome-icon icon="chevron-left" size="2x" />
        </button>
        <WCSelectBox
          v-for="(date, di) in options.slice(
            (daysSet - 1) * 6,
            Math.min(options.length, daysSet * 6),
          )"
          :key="di"
          :id="date.date"
          class="text-center"
          @change="change($event, times[0].start)"
          v-model="reservation.date"
          :primary="true"
          ><span class="font-size-base">{{ date.date | dayOfWeek }}</span
          ><span class="font-size-sm">{{ date.date | formatMonthDay }}</span></WCSelectBox
        >
        <button
          v-if="options.length > 6 && options.length > daysSet * 6"
          @click="daysSet += 1"
          class="align-self-center text-primary wc-chevron unstyled-btn p-0"
          :aria-label="$t('viewNextDateSet')"
        >
          <font-awesome-icon icon="chevron-right" size="2x" />
        </button>
      </WCSelectBoxGroup>
    </fieldset>
    <fieldset>
      <legend class="mt-2 h4">{{ $t('selectTime') }}</legend>
      <WCSelectBoxGroup class="position-relative">
        <button
          v-if="times.length > 5 && timesSet !== 1"
          @click="timesSet -= 1"
          class="align-self-center text-primary wc-chevron-left unstyled-btn p-0 m-0"
          :aria-label="$t('viewPrevTimeSet')"
        >
          <font-awesome-icon icon="chevron-left" size="2x" />
        </button>
        <WCSelectBox
          v-for="(time, ti) in times.slice(
            (timesSet - 1) * 5,
            Math.min(times.length, timesSet * 5),
          )"
          :key="ti"
          :id="time.start"
          class="text-center"
          @change="change(reservation.date, $event)"
          v-model="reservation.time"
          :primary="false"
          ><span class="font-size-sm"
            >{{ time.start | formatTime }} - {{ time.end | formatTime }}</span
          ></WCSelectBox
        >
        <button
          v-if="times.length > numVisibleTimes && times.length > timesSet * numVisibleTimes"
          @click="timesSet += 1"
          class="align-self-center text-primary wc-chevron unstyled-btn pr-3 wc-chevron-right"
          :aria-label="$t('viewNextTimeSet')"
        >
          <font-awesome-icon icon="chevron-right" size="2x" />
        </button>
      </WCSelectBoxGroup>
    </fieldset>
  </div>
</template>

<script>
import WCSelectBoxGroup from '@/modules/forms/components/WCSelectBoxGroup/WCSelectBoxGroup.vue';
import WCSelectBox from '@/modules/forms/components/WCSelectBox/WCSelectBox.vue';
import { dynamicSort } from '@/utils';

export default {
  components: { WCSelectBoxGroup, WCSelectBox },
  model: {
    prop: 'reservation',
    event: 'change',
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    reservation: {
      type: Object,
    },
  },
  data() {
    return {
      areTimesExpanded: false,
      areDaysExpanded: false,
      // Start at set 1. Each time the days/times move right, move to the next set
      daysSet: 1,
      timesSet: 1,
      numVisibleTimes: 5,
    };
  },
  computed: {
    times() {
      const value = this.options.find(date => date.date === this.reservation.date);
      let sortedTimes = [];
      if (value?.times?.length > 0) {
        const availableTimes = value.times.filter(time => time.available === true);
        sortedTimes = dynamicSort(availableTimes, 'start');
      }
      return sortedTimes;
    },
  },
  methods: {
    change(date, time) {
      this.$emit('change', { date, time });
    },
  },
  watch: {
    options: {
      handler() {
        this.areDaysExpanded = false;
        this.areTimesExpanded = false;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-chevron {
  cursor: pointer;
}

.wc-chevron-left {
  cursor: pointer;
  margin-left: $margin-2;
}

.wc-chevron-right {
  margin-left: auto;
  margin-right: $margin-5;
}
</style>
